import React, { lazy } from "react";
import UIDs from "../../UIDs";

const FacilityAccessScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessScreen"));
const FacilityLiveViewScreen = lazy(() => import("../../screens/admin/facility/FacilityLiveViewScreen"));
const EditFacilityAccessScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAccessScreen"));
const FacilityAccessHistoryScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessHistoryScreen"));
const FacilityCheckInScreen = lazy(() => import("../../screens/admin/facility/FacilityCheckInScreen"));
const MemberManagementScreen = lazy(() => import("../../screens/admin/network/MemberManagementScreen"));
const ActivateMembersScreen = lazy(() => import("../../screens/admin/network/ActivateMembersScreen"));
const MemberActivityHistoryScreen = lazy(() => import("../../screens/admin/network/MemberActivityHistoryScreen"));
const SuspensionDetailScreen = lazy(() => import("../../screens/admin/network/SuspensionDetailScreen"));
const EditSuspensionScreen = lazy(() => import("../../screens/admin/network/EditSuspensionScreen"));
const SuspensionScreen = lazy(() => import("../../screens/admin/network/SuspensionScreen"));
const IneligibilityScreen = lazy(() => import("../../screens/admin/network/IneligibilityScreen"));
const TeamManagementScreen = lazy(() => import("../../screens/admin/network/TeamManagementScreen"));
const SidManagementScreen = lazy(() => import("../../screens/admin/network/SidManagementScreen"));
const SidImportScreen = lazy(() => import("../../screens/admin/network/SidImportScreen"));
const CreateAccountsScreen = lazy(() => import("../../screens/admin/network/CreateAccountsScreen"));
const AccountImportScreen = lazy(() => import("../../screens/admin/network/AccountImportScreen"));
const AddOfficialScreen = lazy(() => import("../../screens/admin/network/AddOfficialScreen"));
const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen.jsx"));
const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const CalendarListScreen = lazy(() => import("../../screens/admin/eventcalendar/CalendarListScreen.jsx"));
const EditCalendarScreen = lazy(() => import("../../screens/admin/eventcalendar/EditCalendarScreen.jsx"));
const MessageCenterScreen = lazy(() => import("../../screens/admin/messagecenter/MessageCenterScreen"));
const MessageHistoryScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryScreen"));
const MessageHistoryDetailScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryDetailScreen"));

export const adminRoutes = [
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/facility/facilityaccess",
        uid: UIDs.screens.admin.facility.facilityaccess,
        layout: "/admin",
        element: FacilityAccessScreen ,
    },
    {
        path: "/facility/facilityliveview",
        uid: UIDs.screens.admin.facility.facilityliveview,
        layout: "/admin",
        element: FacilityLiveViewScreen,
    },
    {
        path: "/facility/editfacilityaccess",
        uid: UIDs.screens.admin.facility.editfacilityaccess,
        layout: "/admin",
        element: EditFacilityAccessScreen,
    },
    {
        path: "/facility/facilityaccesshistory",
        uid: UIDs.screens.admin.facility.facilityaccesshistory,
        layout: "/admin",
        element: FacilityAccessHistoryScreen,
    },
    {
        path: "/facility/facilitycheckin",
        uid: UIDs.screens.admin.facility.facilitycheckin,
        layout: "/admin",
        element: FacilityCheckInScreen,
    },
    {
        path: "/network/membermanagement",
        uid: UIDs.screens.admin.network.membermanagement,
        layout: "/admin",
        element: MemberManagementScreen,
    },
    {
        path: "/network/activatemembers",
        uid: UIDs.screens.admin.network.activatemembers,
        layout: "/admin",
        element: ActivateMembersScreen,
    },
    {
        path: "/network/memberactivityhistory",
        uid: UIDs.screens.admin.network.memberactivityhistory,
        layout: "/admin",
        element: MemberActivityHistoryScreen,
    },
    {
        path: "/network/suspensiondetail",
        uid: UIDs.screens.admin.network.suspensiondetail,
        layout: "/admin",
        element: SuspensionDetailScreen,
    },
    {
        path: "/network/editsuspension",
        uid: UIDs.screens.admin.network.editsuspension,
        layout: "/admin",
        element: EditSuspensionScreen,
    },
    {
        path: "/network/suspensions",
        uid: UIDs.screens.admin.network.suspensions,
        layout: "/admin",
        element: SuspensionScreen,
    },
    {
        path: "/network/ineligibility",
        uid: UIDs.screens.admin.network.ineligibility,
        layout: "/admin",
        element: IneligibilityScreen,
    },
    {
        path: "/network/teammanagement",
        uid: UIDs.screens.admin.network.teammanagement,
        layout: "/admin",
        element: TeamManagementScreen,
    },
    {
        path: "/network/sidimport",
        uid: UIDs.screens.admin.network.sidimport,
        layout: "/admin",
        element: SidImportScreen,
    },
    {
        path: "/network/sidmanagement",
        uid: UIDs.screens.admin.network.sidmanagement,
        layout: "/admin",
        element: SidManagementScreen,
    },
    {
        path: "/network/createaccounts",
        uid: UIDs.screens.admin.network.createaccounts,
        layout: "/admin",
        element: CreateAccountsScreen,
    },
    {
        path: "/network/accountimport",
        uid: UIDs.screens.admin.network.accountimport,
        layout: "/admin",
        element: AccountImportScreen,
    },
    {
        path: "/network/addofficial",
        uid: UIDs.screens.admin.network.addofficial,
        layout: "/admin",
        element: AddOfficialScreen,
    },

    {
        path: "/offerings",
        uid: UIDs.screens.admin.offerings,
        layout: "/admin",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/eventcalendar/calendarlist",
        uid: UIDs.screens.admin.eventcalendar.calendarlist,
        layout: "/admin",
        element: CalendarListScreen,
    },
    {
        path: "/eventcalendar/editcalendar",
        uid: UIDs.screens.admin.eventcalendar.editcalendar,
        layout: "/admin",
        element: EditCalendarScreen,
    },
    {
        path: "/messagehistory",
        uid: UIDs.screens.admin.messagehistory,
        layout: "/admin",
        element: MessageHistoryScreen,
    },
    {
        path: "/messagecenter",
        uid: UIDs.screens.admin.messagecenter,
        layout: "/admin",
        element: MessageCenterScreen,
    },
    {
        path: "/messagehistorydetail",
        uid: UIDs.screens.admin.messagehistorydetail,
        layout: "/admin",
        element: MessageHistoryDetailScreen,
    },
];

